<template>
  <div class="grid bg-white">
    <div class="grid-body">
      <invoice-top :invoice="invoice" title="CREATE INVOICE" />
      <item-list :items="invoice.items" :invoice="invoice" :files="files" />

      <div class="row mt-10">
        <div class="col-md-12">
          <button class="btn btn-success btn-block" @click="save()">
            <i class="fa fa-floppy-o" aria-hidden="true"></i> Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import InvoiceTop from "./Components/InvoiceTop";
import ItemList from "./Components/ItemList";
import moment from "moment";
import itemCheck from "./Tools/itemCheck";
import Swal from "sweetalert2";

export default {
  components: {
    InvoiceTop,
    ItemList,
  },
  data() {
    return {
      format: "YYYY-MM-DDT00:00:00.000+07:00",
      invoice: {
        invoice_number: "AUTO",
        invoice_date: moment().format(this.format),
        due_date: moment().format(this.format),
        contact_name: null,
        contact_code: "",
        contact_phone: null,
        contact_email: null,
        contact_tax_id: null,
        contact_address: null,
        reference_invoice_number: null,
        account: {},
        prepaid_by: null,
        transaction_date_time: null,
        transaction_reference_number: null,
        express_reference_number: null,
        vat_percent: 7,
        wht_percent: 0,
        bank_transfer_fee: 0,
        invoice_note: null,
        cost_belong_to: null,
        attachments: null,
        type: this.$route.params.type,
        items: [],
      },
      files: [],
    };
  },
  watch: {
    $route() {
      location.reload();
    },
  },
  methods: {
    async save() {
      if (!this.invoice.account.id) {
        Swal.fire("ERROR", "Please Select Account", "error");
        return false;
      }

      // if(!this.invoice.contact_code) {
      //     Swal.fire(
      //         'ERROR',
      //         'RECIPIENT / SENDER CODE Should Not Be Empty!',
      //         'error'
      //     )
      //     return false;
      // }

      if (itemCheck.run(this.invoice.items)) {
        const { value: value } = await Swal.fire({
          type: "warning",
          title: "Are You Sure",
          confirmButtonText: "YES",
          showCancelButton: true,
        });
        if (value) {
          $(".loading").show();
          var fd = new FormData();
          fd.append("data", JSON.stringify(this.invoice));
          this.files.forEach((val) => {
            fd.append("file[]", val);
          });
          try {
            let res = await axios.post("accounting/invoice", fd);
            if (res) {
              $(".loading").hide();
              toastr.success("Success");
              this.$router.push(
                "/accounting/" + this.$route.params.type + "/invoice/list"
              );
            }
          } catch (error) {
            if (error) {
              $(".loading").hide();
              Swal.fire(
                "ERROR",
                "Something Went Wrong Plese Refresh the Page and Try Again!",
                "error"
              );
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.mt-10 {
  margin-top: 10px;
}
</style>
